var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkEsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M14.589,19.084H7.844c-0.295,0-0.535-0.239-0.535-0.535v-2.071c0-0.295,0.239-0.535,0.535-0.535h6.745 c0.295,0,0.535,0.239,0.535,0.535v2.071C15.123,18.844,14.884,19.084,14.589,19.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M13.386,13.474H9.09c-0.295,0-0.535-0.239-0.535-0.535v-1.923c0-0.295,0.239-0.535,0.535-0.535h4.296 c0.295,0,0.535,0.239,0.535,0.535v1.923C13.92,13.235,13.681,13.474,13.386,13.474z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M12.45,5.105H9.983c-0.06,0-0.108-0.048-0.108-0.108V2.261c0-0.06,0.048-0.108,0.108-0.108h2.467c0.06,0,0.108,0.048,0.108,0.108 v2.737C12.557,5.057,12.509,5.105,12.45,5.105z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 11.24,
    y1: 10.485,
    x2: 11.24,
    y2: 5.105
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 11.216,
    y1: 15.943,
    x2: 11.216,
    y2: 13.926
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.186,
    y1: 8.128,
    x2: 13.289,
    y2: 8.128
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.875,
    y1: 4.365,
    x2: 5.621,
    y2: 4.365
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 19.215,
    y1: 4.365,
    x2: 12.556,
    y2: 4.365
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 2.416,
    y1: 4.365,
    x2: 1.129,
    y2: 4.365
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 0.785,
    y1: 1.872,
    x2: 7.331,
    y2: 1.872
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 4.058,
    y1: 8.125,
    x2: 4.058,
    y2: 5.635
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 2.42,
    y1: 8.128,
    x2: 5.618,
    y2: 8.128
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.42,
    y: 2.399,
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 3.199,
    height: 3.233
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkEsp);
export default __webpack_public_path__ + "static/media/dark-esp.5db440f1b190f3c85bd951c3e4d10fee.svg";
export { ForwardRef as ReactComponent };